import { useParams, useNavigate } from 'react-router-dom'
import { 
  Center,
  Heading,
  useToast,
  VStack,
} from '@chakra-ui/react'
import { Form } from './Form'
import useSeasonChallengeTasks from './hooks/useSeasonChallengeTasks'
import { SeasonChallengeTaskFormData } from '@olagg/validation-schemas/seasonChallengeTask.schema'

const Create = () => {
  const { season_id: seasonId, challenge_id: challengeId } = useParams<{ season_id: string, challenge_id: string }>()
  const navigate = useNavigate()
  const toast = useToast()
  const { createSeasonChallengeTask, loading } = useSeasonChallengeTasks()

  const onSubmit = async (data: SeasonChallengeTaskFormData) => {
    if (!challengeId) return

    try {
      const taskData = {
        ...data,
        gameSeasonChallengeId: Number(challengeId)
      }
      
      await createSeasonChallengeTask(taskData)
      toast({
        title: 'Tarea creada',
        description: 'La tarea ha sido creada exitosamente',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      navigate(`/seasons/${seasonId}/challenges/${challengeId}/tasks`)
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo crear la tarea',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const onCancel = () => {
    navigate(`/seasons/${seasonId}/challenges/${challengeId}/tasks`)
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Crear Nueva Tarea</Heading>

        <Form
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
          isEdit={false}
        />
      </VStack>
    </Center>
  )
}

export default Create;
